import AddOnManager from "AddOnManager";

export default store => {
  return {
    path: "manageSchools",
    getComponent(nextState, cb) {
      const comp = require("./OrganizationV2").default;
      cb(null, comp);
    },
    childRoutes: [AddOnManager(store)],
  };
};
